import { mergeClasses } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import type { EventState, StatusTagProps } from '@/types/events.types';
import { useStatusTagStyles, getStatusStyle } from './StatusTag.styles';

export const StatusTag = ({ state }: StatusTagProps) => {
  const styles = useStatusTagStyles();
  const { t } = useTranslation('dashboard');

  const statusLabelMap: Record<EventState, string> = {
    DRAFT: t('status.draft'),
    SUBMITTED: t('status.submitted'),
    UNDER_REVIEW: t('status.underReview'),
    CONFIRMED: t('status.confirmed'),
    DECLINED: t('status.declined'),
    SUBMITTED_FOR_CANCELLATION: t('status.submittedForCancellation'),
    COMPLETED: t('status.completed'),
    CANCELLED: t('status.cancelled'),
    NO_OCCURRENCE: t('status.noOccurrence'),
  };

  const label = statusLabelMap[state];

  return (
    <span
      className={mergeClasses(styles.badge, getStatusStyle(state, styles))}
      role="status"
      aria-label={label}
    >
      {label}
    </span>
  );
};

StatusTag.displayName = 'StatusTag';
